var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyProgramHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.8 19.4038H21.2V23H19.4H8.6H6.8V19.4038Z",
    fill: "#FAE232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.194 13.4163L23 8.61538L21.2 17.6058H6.8L5 8.61538L9.806 13.4163L14 6L18.194 13.4163Z",
    fill: "#FAE232"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyProgramHighlighted);
export default __webpack_public_path__ + "static/media/loyalty_program_highlighted.92f32da8a534916d08825768224b54af.svg";
export { ForwardRef as ReactComponent };